/**
 * Client-side context the analytics backend can't derive from the request alone.
 * Used by the tracking beacons (body fields) and the /out clickout redirect
 * (query params — a top-level GET has no body).
 */

// iPadOS 13+ Safari and its WKWebView report a Mac desktop UA, so server-side UA
// parsing counts iPads as desktops. Touch support is the only client-side tell — the
// same signal ua-parser-js 2.x withFeatureCheck() uses, including its >2 threshold
// (real iPads report 5, Macs 0). Its extra navigator.standalone guard is deliberately
// NOT copied: it only protects against touch-emulating Mac browsers, and would break
// the hint inside the Capacitor WKWebView if the property ever went missing there.
export function deviceHint() {
  return navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 2 ? 'tablet' : undefined
}

// The external referrer of this document, if any. Same-origin (internal SPA nav)
// is stripped so the server buckets it as 'direct'. Reduced to scheme+host before
// sending: the server only ever keeps the hostname, and the full URL would otherwise
// flow through /out query strings into access logs (data minimization). protocol+host
// instead of URL.origin so android-app:// referrers survive (their origin is 'null').
export function externalReferrer() {
  const ref = document.referrer
  if (!ref || ref.startsWith(window.location.origin)) return undefined
  try {
    const { protocol, host } = new URL(ref)
    return host ? `${protocol}//${host}` : undefined
  } catch {
    return undefined
  }
}
